
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route, NavigationGuardNext } from 'vue-router';

import store from '@/store';

import FondoDiagonal from '@/componentes/UI/FondoDiagonal.vue';
import ProgresoPasos from '@/componentes/ProgresoPasos.vue';
import InformacionPago from '@/componentes/pago/InformacionPago.vue';
import EleccionModalidad from '@/componentes/pago/EleccionModalidad.vue';

import { getMatriculaEstudiante, MatriculaEstudianteI } from '@/assets/api/matricula';
import { postPagoMatricula, RespuestaWebpayI, redirectPostWebpay } from '@/assets/api/pagos';
import HeaderPrincipal from "@/componentes/UI/HeaderPrincipal.vue";

@Component({
  components: {
    HeaderPrincipal,
    FondoDiagonal, ProgresoPasos, InformacionPago, EleccionModalidad,
  },
})
export default class PagoMatricula extends Vue {
  matricula: MatriculaEstudianteI = {} as MatriculaEstudianteI;
  modalidad: number | null = null;
  modo = 1;
  cargando = false;
  error = '';

  // Computed properties for colors
  get planColor(): string {
    const colorVar = this.$store.getters.colorPlan;

    if (colorVar.includes('var(')) {
      const colorMap: Record<string, string> = {
        'var(--azul-institucional)': '#375282',
        'var(--verde-institucional)': '#40b99d',
        'var(--celeste-institucional)': '#56c0e8',
        'var(--azul-enfermeria)': '#273470',
        'var(--rojo-obstetricia)': '#AB2326',
        'var(--verde-agronomia)': '#639244',
        'var(--verde-forestal)': '#136E49',
        'var(--naranjo-industrial)': '#F06A26',
        'var(--amarillo-social)': '#F9b81C',
        'var(--celeste-psicologia)': '#00ACB4',
        'var(--rosado-informatica)': '#D60B51',
        'var(--verde-terapia-ocupacional)': '#336666',
        'var(--azul-ing-comercial)': '#006699',
        'var(--naranjo)': '#f27c08',
        'var(--morado-adm-publica)': '#333366',
        'var(--gris-derecho)': '#666666',
        'var(--amarillo-ing-renovables)': '#8c9c27'
      };

      return colorMap[colorVar] || '#375282';
    }

    return colorVar;
  }

  get planTextColor(): string {
    const colorVar = this.$store.getters.colorTextoPlan;

    if (colorVar.includes('var(')) {
      const colorMap: Record<string, string> = {
        'var(--azul-institucional)': '#375282',
        'var(--verde-institucional)': '#40b99d',
        'var(--celeste-institucional)': '#56c0e8',
        'var(--azul-enfermeria)': '#273470',
        'var(--rojo-obstetricia)': '#AB2326',
        'var(--verde-agronomia)': '#639244',
        'var(--verde-forestal)': '#136E49',
        'var(--naranjo-industrial)': '#F06A26',
        'var(--amarillo-social)': '#F9b81C',
        'var(--celeste-psicologia)': '#00ACB4',
        'var(--rosado-informatica)': '#D60B51',
        'var(--verde-terapia-ocupacional)': '#336666',
        'var(--azul-ing-comercial)': '#006699',
        'var(--naranjo)': '#f27c08',
        'var(--morado-adm-publica)': '#333366',
        'var(--gris-derecho)': '#666666',
        'var(--amarillo-ing-renovables)': '#8c9c27'
      };

      return colorMap[colorVar] || '#375282';
    }

    return colorVar;
  }

  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<PagoMatricula>) {
    const promesaMatricula = getMatriculaEstudiante(store.getters.idEstudiante);

    Promise.all([promesaMatricula])
      .then(([matricula]) => {
        if (matricula.orden_compra && matricula.orden_compra.estado_pago === 1) {
          next({ name: 'resumen' });
          return;
        }
        next((vm) => {
          vm.matricula = matricula;
        });
      })
      .catch(() => {
        next({ name: store.getters.linkInicio });
      });
  }

  get precioMatricula(): number {
    return this.matricula.monto_final + this.matricula.beneficios_monto_total;
  }

  get montoBeneficios(): number {
    return this.matricula?.beneficios_monto_total ?? 0;
  }

  get precioFinal(): number {
    return this.matricula?.monto_final ?? 0;
  }

  @Watch('modalidad')
  cambioModalidad(): void {
    if (this.modalidad === 2) {
      this.modo = 1; // modo presencial
    } else {
      this.modo = 7; // webpay
    }
  }

  async enviar(): Promise<void> {
    if (store.getters.idEstudiante && (this.modalidad || this.precioFinal === 0)) {
      this.cargando = true;
      this.error = '';

      // si el monto final es 0 siempre enviar modo 1 (caja)
      if (this.precioFinal === 0) {
        this.modo = 1;
      }

      try {
        const respuesta = await postPagoMatricula({
          estudiante_id: store.getters.idEstudiante,
          forma_pago_id: this.modo,
        });

        if (this.modo === 7) {
          // redirigir en caso de webpay
          const respWebpay = respuesta as RespuestaWebpayI;
          redirectPostWebpay(respWebpay.url_redirect, respWebpay.token_webpay);
        } else {
          store.commit('actualizarEtapa', 3);
          await this.$nextTick();
          this.$router.push({ name: 'pago arancel' });
        }
      } catch (error: any) {
        this.cargando = false;

        if (error.mensaje) {
          this.error = error.mensaje;
        } else {
          this.error = 'Lo sentimos, ha ocurrido un error en el sistema. Por favor intenta nuevamente y si el problema persiste ponte en contacto con el encargado de matrícula';
        }
      }
    }
  }
}
